<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<p class="x-2-Chapter-title"><a href="#/Text/Section0003">Acknowledgments</a><br/></p>
<p class="Basic-Paragraph">I offer my sincere thanks to my colleagues in the field of paranormal investigation, especially Jackie Ganiy, Loyd Auerbach, Nick Groff, Zak Bagans, and Jeff Bellanger, whose inspiration, support, and encouragement I highly value.</p>
<p class="Basic-Paragraph">I am also grateful to Doug Carnahan, producer and host of the <span class="char-style-override-6">Haunted Truth</span> radio show, who provided me forums to dis<a id="x.3788"></a>cuss my ideas and experiences with colleagues at Preston Castle and Virginia City; and to my friend Zak Bagans for opportunities to appear with him on the Travel Channel shows <span class="char-style-override-6">Ghost Adventures</span> and <span class="char-style-override-6">Aftershocks.</span></p>
<p class="Basic-Paragraph">Many thanks to my literary agent, Sue Clark, for the support and guidance that has proved to be invaluable on countless occasions and the staff of Pelican Publishing, who, for many years, have patiently guided me through the process of producing and marketing my books.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// GHPPe_ack.vue?b040b178